import { apiFailureCase } from '../../../../utils/reduxOperations';

export function handleLoginProcessFailed(state, payload) {
    return {
        ...state,
        loginApi:apiFailureCase(state.loginApi,payload)
    };
}
